import Link from 'next/link'
import styled from 'styled-components'

import { colors, media } from 'shared/lib'
import { ArticleSeoTag, ArticleSeoTags } from 'shared/types/ArticleSeoTag'

type TagProps = {
  section: ArticleSeoTag
}

const Tag = ({ section }: TagProps) => {
  return (
    <TagContainer>
      {section?.openInNewTab ? (
        <a data-qa="ArticleTagLink" href={section?.url} rel="noopener noreferrer" target="_blank">
          {section?.text}
        </a>
      ) : (
        <Link data-qa="ArticleTagLink" href={`/${section?.url}`}>
          {section?.text}
        </Link>
      )}
    </TagContainer>
  )
}

type ArticleSeoTagsSectionProps = {
  section: ArticleSeoTags
}

export const ArticleSeoTagsSection = ({ section }: ArticleSeoTagsSectionProps) => {
  if (!section?.subsections || section?.subsections?.length === 0) {
    return null
  }

  return (
    <Container data-qa="ArticleTagsSection">
      {section?.subsections?.map((subsection) => (
        <Tag key={subsection?.uuid} section={subsection} />
      ))}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
  `};
`
const TagContainer = styled.div`
  a {
    color: ${colors.FC2_RED};
    font-family: 'Helvetica Neue'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
    font-size: 12px;
    font-weight: 400;
    line-height: 125%;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  }
`
